import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const isDev = process.env.REACT_APP_ENV_MODE === 'dev';

type BlockDialogType = 'push' | 'pop';

interface StoreState {
  isOpen: boolean;
  type: BlockDialogType;
  onOk: () => void;
  onCancel: () => void;
}

interface StoreActions {
  setOpen: () => void;
  setClose: () => void;
  setType: (type: BlockDialogType) => void;
  setOnOk: (onOk: () => void) => void;
  setOnCancel: (onCancel: () => void) => void;
  clearState: () => void;
}

const initialState: StoreState = {
  isOpen: false,
  type: 'push',
  onOk: () => {},
  onCancel: () => {},
};

const useBlockDialogStore = create<StoreState & StoreActions>()(
  devtools(
    set => ({
      ...initialState,
      setOpen: () => set({ isOpen: true }),
      setClose: () => set({ isOpen: false }),
      setType: (type: BlockDialogType) => set({ type }),
      setOnOk: (onOk: () => void) => set({ onOk }),
      setOnCancel: (onCancel: () => void) => set({ onCancel }),
      clearState: () => set({ ...initialState }),
    }),
    { name: 'BlockDialogStore', enabled: isDev },
  ),
);

export default useBlockDialogStore;
